import { render, staticRenderFns } from "./ModalAddCollection.vue?vue&type=template&id=54645913"
import script from "./ModalAddCollection.vue?vue&type=script&lang=js"
export * from "./ModalAddCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports